import { Breadcrumbs, Typography, Link, breadcrumbsClasses } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { NavigateOptions, useNavigate } from 'react-router';

export interface Crumb {
  label: string;
  to?: string;
  options?: NavigateOptions;
  beforeNavigate?: () => void;
  onClick?: () => void;
}

export interface BreadcrumbProps {
  items: Crumb[];
}

export default function Breadcrumb({ items }: BreadcrumbProps): React.JSX.Element {
  const navigate = useNavigate();

  const handleNavigation = ((item: Crumb): void => {
    if (item.onClick) {
      item.onClick();
      return;
    }

    if (item.beforeNavigate) {
      item.beforeNavigate();
    }

    navigate(item.to!, item.options);
  });

  return (
    <Breadcrumbs
      separator={<NavigateNextIcon fontSize="inherit" />}
      sx={{
        [`& .${breadcrumbsClasses.separator}`]: {
          mx: 0.5,
        },
      }}
    >
      {items.map((item, index) =>
        (item.to || item.onClick ? (
          <Link
            underline="hover"
            sx={{
              cursor: 'pointer',
            }}
            onClick={() => handleNavigation(item)}
            key={index}
          >
            <Typography
              variant="bodySmall"
              sx={{
                color: 'text.primary',
              }}
            >
              {item.label}
            </Typography>
          </Link>
        ) : (
          <Typography
            variant="bodySmall"
            color="onSurfaceVariant"
            key={index}
          >
            {item.label}
          </Typography>
        )
        ))}
    </Breadcrumbs>
  );
}
